<template>
  <div>
    <apexcharts
      type="heatmap"
      :height="height"
      :options="chartOptions"
      :series="series"
    ></apexcharts>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
const defaultOptions = {
  title: "Heatmap",
  unit: "",
  colors: ["#00aaaa"],
};

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      required: false,
      default: () => defaultOptions,
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  created() {
    if (this.series)
      this.maxValue = Math.max(
        ...this.series.flatMap((serie) => serie.data.map((point) => point))
      );
    this.buildOptions();

    console.log(
      this.maxValue,
      this.chartOptions.plotOptions.heatmap.colorScale
    );
  },
  data() {
    return {
      maxValue: 100,
      mergedOptions: {},
      chartOptions: {
        chart: {
          type: "heatmap",
          events: {
            click: function (event, chartContext, opts) {
              void event;
              const element =
                chartContext?.w?.config?.series[opts.seriesIndex]?.data[
                  opts.dataPointIndex
                ];
              console.log(element);
            },
          },
        },
        plotOptions: {
          heatmap: {
            colorScale: {
              ranges: [],
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: [],
        title: {
          text: "Heatmap",
        },
        xaxis: {
          categories: [...Array(12)].map((_, index) => index + 1),
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value;
            },
          },
        },
      },
    };
  },
  methods: {
    unitBuilder(unit) {
      return function (value) {
        return value + " " + unit;
      };
    },
    buildOptions() {
      this.mergedOptions = { ...defaultOptions, ...this.options };
      this.chartOptions.title.text = this.mergedOptions.title;
      this.chartOptions.colors = this.mergedOptions.colors;
      this.chartOptions.tooltip.y.formatter = this.unitBuilder(
        this.mergedOptions.unit
      );
      this.chartOptions.xaxis.categories = this.mergedOptions.categories;
      this.chartOptions.plotOptions.heatmap.colorScale.ranges = [
        {
          from: 0,
          to: this.maxValue * 0.1, // 0-10%
          color: "#ffcdcd", // Rot
        },
        {
          from: this.maxValue * 0.1,
          to: this.maxValue * 0.3, // 10-30%
          color: "#ffb84d", // Orange
        },
        {
          from: this.maxValue * 0.3,
          to: this.maxValue * 0.6, // 30-60%
          color: "#ffff4d", // Gelb
        },
        {
          from: this.maxValue * 0.6,
          to: this.maxValue * 0.9, // 60-80%
          color: "#80ff80", // Grün
        },
        {
          from: this.maxValue * 0.9,
          to: this.maxValue, // 80-100%
          color: "#60df60", // Green
        },
      ];
    },
  },
};
</script>

<style scoped></style>
